import { frontendURL } from 'dashboard/helper/URLHelper';
const CalendarPage = () => import('./pages/CalendarPage.vue');

const meta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/calendar'),
      name: 'workspace_calendar',
      component: CalendarPage,
      meta,
    },
  ],
};
